import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import { URL_CATALOG } from '@modules/ai-framework/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

// Consome o catálogo publicado pela spec-001 (GET /catalog, GET /catalog/:slug).
// Envelope { status, message, value } de response.data — status lido pelo caller.
class APIAiFrameworkCatalog extends APITemplate {
  async getCatalog(categoria) {
    const params = formatQueryParams({ categoria })
    const r = await con.get(URL_CATALOG + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async getCatalogDetail(slug) {
    if (!slug) {
      return this.buildErrorResponse({
        message: 'slug obrigatório',
        status: 400,
        value: null,
      })
    }
    const r = await con.get(`${URL_CATALOG}/${slug}`)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
// A classe NÃO é exportada — ninguém a consome (verificado por grep em src/),
// e export sem consumidor é código morto que o próximo leitor tenta preservar.
const apiAiFrameworkCatalog = new APIAiFrameworkCatalog()

export { apiAiFrameworkCatalog }
